import type { StateCreator } from 'zustand';
import { getInitialTheme, type Theme } from '@/constants/theme';

export type UserPreferencesSlice = {
  userPreferences: {
    theme: Theme;
  };
  setUserTheme: (theme: Theme) => void;
};

export const createUserPreferencesSlice: StateCreator<UserPreferencesSlice> = (
  set,
) => ({
  userPreferences: {
    theme: getInitialTheme(),
  },
  setUserTheme: (theme) =>
    set((state) => ({
      ...state,
      userPreferences: {
        ...state.userPreferences,
        theme,
      },
    })),
});
